const isLogsEnabled = process.env.NEXT_PUBLIC_APP_LOGS_ENABLED === "true";

export const logger = {
    error: (...messages: unknown[]) => {
        if (isLogsEnabled) {
            console.error("\x1b[1m\x1b[31m[ERROR]\x1b[0m", ...messages);
        }
    },
    log: (...messages: unknown[]) => {
        if (isLogsEnabled) {
            console.log("\x1b[1m\x1b[33m[LOG]\x1b[0m", ...messages);
        }
    },
};
